/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoWeiChaXunTiaoJian,
  GuangGaoWeiChuangJianGengXinXinXi,
  ResponseApiGuangGaoWeiXiangQing,
  ResponseApiIPageGuangGaoWeiLieBiao,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoWeiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoWeiGuanLi
   * @name AdSlotListUsingPost
   * @summary 分页查询广告位列表
   * @request POST:/dsp-admin/api/adslots
   * @secure
   */
  adSlotListUsingPost = (
    查询条件参数: GuangGaoWeiChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoWeiLieBiao, void>({
      path: `/dsp-admin/api/adslots`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoWeiGuanLi
   * @name CreateAdSlotUsingPost
   * @summary 创建广告位
   * @request POST:/dsp-admin/api/adslots/create
   * @secure
   */
  createAdSlotUsingPost = (
    createDTO: GuangGaoWeiChuangJianGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/adslots/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoWeiGuanLi
   * @name GetAdSlotUsingPost
   * @summary 获取广告位详情
   * @request POST:/dsp-admin/api/adslots/{id}
   * @secure
   */
  getAdSlotUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoWeiXiangQing, void>({
      path: `/dsp-admin/api/adslots/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoWeiGuanLi
   * @name UpdateAdSlotUsingPut
   * @summary 更新广告位
   * @request PUT:/dsp-admin/api/adslots/{id}
   * @secure
   */
  updateAdSlotUsingPut = (
    createDTO: GuangGaoWeiChuangJianGengXinXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/adslots/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoWeiGuanLi
   * @name DeleteAdSlotUsingDelete
   * @summary 删除广告位
   * @request DELETE:/dsp-admin/api/adslots/{id}
   * @secure
   */
  deleteAdSlotUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adslots/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoWeiGuanLi();
